import { keyframes } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { RevealFade, RevealSlide, RevealZoom } from "../../../../utils/Reveal";

// Keyframes for typing and blinking cursor
const typing = keyframes`
  from { width: 0 }
  to { width: 100% }
`;

const blink = keyframes`
  from, to { border-color: transparent }
`;

// Keyframes for slide-up animation
const slideUp = keyframes`
  from { transform: translateY(0); opacity: 1; }
  to { transform: translateY(-100%); opacity: 0; }
`;

const SplashScreen: React.FC<{ onComplete: () => void }> = ({ onComplete }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      const exitTimer = setTimeout(() => {
        onComplete();
      }, 1000); // Duration of the exit animation

      return () => clearTimeout(exitTimer);
    }, 1500); // Duration before starting the exit animation

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "100vh",
        animation: isExiting ? `${slideUp} 2s forwards` : "none",
        position: "fixed",
        background: "transparent",
        color: "#fff",
        width: "100%",
        top: 0,
        left: 0,
      }}
    >
      <RevealFade>
        <Typography
          sx={{
            fontSize: {
              xs: "40px",
              sm: "70px",
              md: "80px",
              lg: "100px",
              xl: "110px",
            },
            background: "transparent",
            fontFamily: "Poppins",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          designed by
        </Typography>
      </RevealFade>
      <Box sx={{ display: "flex",justifyContent:"center",width:"100%",maxWidth:{xs:250,sm:300, md:"500px"} }}>
        <RevealSlide direction="down">
          <Typography
            sx={{
              fontSize: {
                xs: "40px",
                sm: "70px",
                md: "80px",
                lg: "100px",
                xl: "110px",
              },
              background: "transparent",
              fontFamily: "Poppins",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            M
          </Typography>
        </RevealSlide>
        <RevealSlide direction="up">
          <Typography
            sx={{
              fontSize: {
                xs: "40px",
                sm: "70px",
                md: "80px",
                lg: "100px",
                xl: "110px",
              },
              background: "transparent",
              fontFamily: "Poppins",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            A
          </Typography>
        </RevealSlide>
        <RevealSlide direction="down">
          <Typography
            sx={{
              fontSize: {
                xs: "40px",
                sm: "70px",
                md: "80px",
                lg: "100px",
                xl: "110px",
              },
              background: "transparent",
              fontFamily: "Poppins",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            N
          </Typography>
        </RevealSlide>
        <RevealSlide direction="up">
          <Typography
            sx={{
              fontSize: {
                xs: "40px",
                sm: "70px",
                md: "80px",
                lg: "100px",
                xl: "110px",
              },
              background: "transparent",
              fontFamily: "Poppins",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            I
          </Typography>
        </RevealSlide>
      </Box>
    </Box>
  );
};

export default SplashScreen;
